<script setup lang="ts">
import type { Component } from "vue";

withDefaults(
  defineProps<{
    title: string;
    subtitle?: string;
    icon?: Component;
    theme?: "primary" | "secondary" | "tertiary";
    ctaLink?: string;
    ctaText?: string;
  }>(),
  {
    theme: "primary",
    ctaText: "Vedi tutto",
  }
);
</script>

<template>
  <div :class="['p-5', (theme === 'primary' || theme === 'tertiary') && 'border border-primary-100', theme === 'secondary' && 'bg-primary-950 text-white', theme === 'tertiary' && 'bg-primary-50']">
    <h3 class="flex items-center text-xl font-semibold mb-5">
      <component :is="icon" class="w-12 h-12 me-3 flex-shrink-0" :class="(theme === 'primary' || theme === 'secondary') && 'text-themeGray'" />
      <span>
        <span class="block text-3xl">{{ title }}</span>
        {{ subtitle }}
      </span>
    </h3>
    <div :class="['flex flex-col gap-y-6', theme === 'secondary' && 'divide-y divide-white/50 *:pt-5 first:*:pt-0']">
      <slot></slot>
    </div>
    <div class="text-right mt-5" v-if="ctaLink">
      <NuxtLink :href="ctaLink" :title="ctaText" :class="theme === 'secondary' ? 'font-semibold text-tertiary-400 hover:text-tertiary transition-colors' : 'link'">{{ ctaText }}</NuxtLink>
    </div>
  </div>
</template>
